<template>
  <div class="anasayfa">
    <AppMain>


      <div class="container-fluid">
        <div class="nk-content-inner">
          <div class="nk-content-body">
            <div class="nk-block-head nk-block-head-sm">
              <div class="nk-block-between">
                <div class="nk-block-head-content">
                  <h3 class="nk-block-title page-title">Tfon Makine Fuar Görüşme Takip Uygulaması</h3>
                  <div class="nk-block-des text-soft">
                    <p>Anasayfa</p>
                  </div>
                </div>

              </div>
            </div>
            <div class="nk-block">

              <div class="row">
                <!-- Kişiler Kartı -->
                <div class="col-sm-6 col-md-4 col-lg-6 col-xl-4">
                  <div class="card box-dotted h-100">
                    <div class="card-body">
                      <em class="icon icon-lg ni ni-user-add text-success"></em>
                      <h5 class="title mt-2 mb-3">Kişiler</h5>
                      <div class="amount h3">{{ cardveriler.kisiler }}</div>

                    </div>
                  </div>
                </div>

                <!-- Firmalar Kartı -->
                <div class="col-sm-6 col-md-4 col-lg-6 col-xl-4">
                  <div class="card box-dotted h-100">
                    <div class="card-body">
                      <em class="icon icon-lg ni ni-building text-primary"></em>
                      <h5 class="title mt-2 mb-3">Firmalar</h5>
                      <div class="amount h3">{{ cardveriler.firmalar }}</div>

                    </div>
                  </div>
                </div>


                <!-- Etkinlikler Kartı -->
                <div class="col-sm-6 col-md-4 col-lg-6 col-xl-4">
                  <div class="card box-dotted h-100">
                    <div class="card-body">
                      <em class="icon icon-lg ni ni-calendar text-info"></em>
                      <h5 class="title mt-2 mb-3">Etkinlikler</h5>
                      <div class="amount h3">{{ cardveriler.etkinlikler }}</div>

                    </div>
                  </div>
                </div>

              </div>
              <div class="row mt-2">
                <!-- Son Yapılan Görüşmeler Kartı -->
                <div class="col-xxl-6">
                  <div class="card h-100">
                    <div class="card-body flex-grow-0 py-2">
                      <div class="card-title-group">
                        <div class="card-title">
                          <p class="small">Son Görüşmeler</p>
                        </div>

                      </div>
                    </div>
                    <div class="table-responsive">
                      <table class="table table-middle mb-0">
                        <thead class="table-light table-head-sm">
                          <tr>
                            <th class="tb-col"><span class="overline-title">FİRMA</span></th>
                            <th class="tb-col tb-col-end"><span class="overline-title">ETKİNLİK</span></th>
                            <th class="tb-col tb-col-end"><span class="overline-title">FİRMA YETKİLİSİ</span></th>
                            <th class="tb-col tb-col-end"><span class="overline-title">GÖRÜŞME YAPAN</span></th>
                            <th class="tb-col tb-col-end"><span class="overline-title">TARİH</span></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="gorusmebilgi in cardveriler.gorusmebilgiler" :key="gorusmebilgi.id">
                            <td class="tb-col">
                              {{ gorusmebilgi.firma_ad }}
                            </td>
                            <td class="tb-col tb-col-end">{{ gorusmebilgi.etkinlik_ad }}</td>
                            <td class="tb-col tb-col-end">{{ gorusmebilgi.kisi_ad }}</td>
                            <td class="tb-col tb-col-end">{{ gorusmebilgi.gorusmeyapan_ad }}</td>
                            <td class="tb-col tb-col-end">{{ gorusmebilgi.tarih }}</td>
                          </tr>



                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="col-md-6 col-xxl-6">
                  <div class="card h-100">
                    <div class="card-body">
                      <div class="card-title-group">
                        <div class="card-title">
                          <p class="small">Son Hareketler</p>
                        </div>
                      </div>
                      <div class="list-group-dotted">
                        <div class="list-group-wrap flex-column">
                          <div class="py-1 px-2" v-for="hareket in cardveriler.hareketler" :key="hareket.id">
                            <div class="d-flex flex-wrap justify-content-between">
                              <span class="small">{{hareket.kullanici_ad}}</span>
                              <span class="small">{{hareket.aciklama}}</span>
                              <span  class="change down small">{{hareket.tarih}}</span>
                              </div>
                          </div>
                         
                        </div>
                      </div>
                    </div>
                  </div>
                </div>





              </div>
            </div>

          </div>
        </div>
      </div>




    </AppMain>
  </div>
</template>

<script>
import AppMain from "@/components/AppMain.vue";
import axiosCustom from "@/services/axiosCustom";




export default {
  name: "AnasayfaView",
  components: {
    AppMain,







  },
  mounted() {


    this.$globalVariable.jwtkontrol();
    this.cardVerilerGetir();



  },
  data() {
    return {



      cardveriler: [],



    };
  },
  methods: {
    cardVerilerGetir() {
      axiosCustom
        .get("anasayfa")
        .then((response) => {
          this.cardveriler = response.data;
        })
        .catch((error) => {
          console.error("Veri çekme hatası: ", error);
        });
    },
















  },
};
</script>
